const styles = (theme) => ({
	container: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		gap: 1,
		padding: "48px 24px",
		textAlign: "center",
	},
	icon: {
		fontSize: "48px",
		color: theme.palette.text.secondary,
		opacity: 0.6,
	},
	titulo: {
		color: theme.palette.text.primary,
		fontWeight: 600,
	},
	descricao: {
		color: theme.palette.text.secondary,
		maxWidth: "480px",
	},
});

export default styles;
